<template>
  <app-popup-page>
    <div class="w-full my-auto">
      <section class="md:flex-nowrap flex flex-wrap mb-10">
        <div class="md:w-1/2">
          <h1 class="text-primary text-title-md">Sicurezza</h1>
          <div class="prose">
            <p>
              Abbiamo a cuore la tua sicurezza.<br />
              Per questo adottiamo tutte le misure necessarie per garantirti la
              massima protezione possibile quando operi on line o effettui
              pagamenti (fisici e digitali).
            </p>
            <p>
              Leggi le informazioni e i consigli utili che abbiamo raccolto per
              te.
            </p>
          </div>
        </div>
        <img
          class="md:w-1/2 object-contain w-full max-w-md mx-auto"
          src="/assets/Desktop/12_Footer/IBL_Sito_ControCorrente_Volto_PopUp_Sicurezza.png"
        />
      </section>
      <section class="mb-10">
        <h2 class="text-primary text-title-sm">ACCESSO INTERNET BANKING</h2>
        <div class="prose">
          <p>
            Per accedere alla tua area riservata ed identificarti correttamente,
            sono necessari codice utente, password e codice OTP (One Time
            Password). Codice utente e Password ti saranno comunicati in fase di
            attivazione del conto mentre l'OTP è un codice che deve essere
            generato ad ogni accesso tramite IBL Pass Code, un dispositivo di
            sicurezza accessibile tramite App IBL E-Bank, da installare sul tuo
            smartphone.
          </p>
          <p>
            Ti consigliamo di conservare accuratamente e separatamente codici e
            credenziali di accesso.
          </p>
          <p>
            La password è soggetta a scadenza e periodicamente ti verrà
            richiesto di cambiarla.
          </p>
          <p>
            Nel caso in cui il tuo smartphone lo preveda, è possibile accedere
            all’App IBL E-Bank in modo più rapido e sicuro tramite il
            riconoscimento biometrico, attivando le funzioni Face ID
            (Riconoscimento facciale) e Finger Print (Impronta digitale).
          </p>
        </div>
      </section>
      <section class="mb-10">
        <h2 class="text-primary text-title-sm ">
          <span>TUTELA ANCHE TU LA TUA SICUREZZA: </span
          ><span>ATTENZIONE ALLE FRODI ON LINE!</span>
        </h2>
        <div class="prose">
          <p>
            Anche tu puoi fare molto per tutelare i tuoi dati bancari prestando
            attenzione alle comunicazioni che ricevi e ai siti che visiti on
            line. A seguire alcune informazioni sulle tipologie di frodi più
            diffuse.
          </p>
        </div>
        <div class="sm:flex-nowrap flex flex-wrap my-8">
          <div
            class=" border-primary rounded-2xl flex flex-none w-40 h-40 p-2 mb-2 mr-2 border"
          >
            <h3 class="text-title-sm text-primary m-auto">Phishing</h3>
          </div>
          <div class="container-section-security">
            <div class="sm:w-full prose">
              <p>
                Il phishing è una particolare tipologia di truffa online
                realizzata al fine di accedere in modo illecito a conti correnti
                bancari o ad altri servizi.
                <br />
                La maggior parte dei tentativi di phishing avviene tramite
                l’invio di e-mail, solo apparentemente provenienti da istituti
                di credito.
                <br />
                Il testo delle mail in genere fa riferimento a richieste di
                aggiornamenti o problemi legati all'account dell'utente e
                contiene un link che rimanda a pagine fittizie molto simili a
                quelle originali in grado di trarre in inganno il cliente.
                <br />
                I dati inseriti su tali siti potranno essere usati dal
                truffatore a scopo fraudolento.
              </p>
            </div>
          </div>
        </div>
        <div class="sm:flex-nowrap flex flex-wrap my-8">
          <div
            class=" border-primary rounded-2xl flex flex-none w-40 h-40 p-2 mb-2 mr-2 border"
          >
            <h3 class="text-title-sm text-primary m-auto">Vishing</h3>
          </div>
          <div class="container-section-security">
            <div class="sm:w-full prose">
              <p>
                Il vishing o “voice phishing” è un’attività di phishing
                realizzata tramite telefono.<br />
                L’autore di questo tipo di truffa telefona presentandosi a nome
                della Banca, chiede al cliente di fornire informazioni utili per
                accedere ai suoi conti per esigenze varie, quali ad esempio
                un'attività di aggiornamento, al fine di ottenere i dati
                necessari per poter accedere al conto della vittima e derubarla.
              </p>
            </div>
          </div>
        </div>
        <div class="sm:flex-nowrap flex flex-wrap my-8">
          <div
            class=" border-primary rounded-2xl flex flex-none w-40 h-40 p-2 mb-2 mr-2 border"
          >
            <h3 class="text-title-sm text-primary m-auto">SMISHING</h3>
          </div>
          <div class="container-section-security">
            <div class="sm:w-full prose">
              <p>
                Tentativo di truffa realizzato tramite l’invio di SMS che
                simulano le comunicazioni ufficiali della banca e invitano a
                cliccare su un link con l’obiettivo di acquisire dati personali
                e di accesso al conto.
              </p>
            </div>
          </div>
        </div>
        <div class="sm:flex-nowrap flex flex-wrap my-8">
          <div
            class=" border-primary rounded-2xl flex flex-none w-40 h-40 p-2 mb-2 mr-2 border"
          >
            <h3 class="text-title-sm text-primary m-auto">SPOOFING</h3>
          </div>
          <div class="container-section-security">
            <div class="sm:w-full prose">
              <p>
                Attacco informatico basato sulla falsificazione dell’identità e
                spesso effettuato tramite telefono. <br />
                Il numero di telefono da cui il cliente riceve la telefonata o
                gli SMS appare direttamente riconducibile alla banca. <br />
                I messaggi compaiono nella chat pregressa con la banca
                mischiandosi con quelli originali e traendo in inganno il
                cliente che può confondere l'SMS ricevuto con una comunicazione
                ufficiale.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="mb-10">
        <div class="mb-5 prose">
          <p>Per non incorrere in simili inconvenienti, tieni presente che:</p>
        </div>
        <div
          class="rounded-2xl sm:flex-nowrap flex flex-wrap p-2 mb-4 border border-yellow-400"
        >
          <img
            src="/assets/Desktop/12_Footer/IBL_Sito_ControCorrente_Icona_Attenzione_PopUp_Sicurezza.png"
            class="max-h-32 md:mr-4 mx-auto"
          />
          <div class="container-section-security">
            <div class="sm:w-full prose">
              <p>
                IBL Banca non ti chiederà mai telefonicamente o via email o sms,
                dati riguardanti codici di accesso, password o pin, o altre
                informazioni relative al tuo account. Né ti farà mai effettuare
                sotto dettatura bonifici o transazioni verso terzi.
              </p>
              <p>
                Nel caso dovessi ricevere comunicazioni sospette con richieste
                per aggiornamenti, verifiche credenziali o altro, non fornire
                mai i tuoi dati. Contatta subito IBL Banca chiamando il Servizio
                Clienti (800 919090) o recati in filiale.
              </p>
            </div>
          </div>
        </div>
        <div class="rounded-2xl sm:w-max p-2 mb-4 border border-yellow-400">
          <h4 class="text-xl text-center text-yellow-400">
            <a
              href="https://www.iblbanca.it/-/media/Project/IBL/ControCorrente/Documenti/ControCorrente_Scheda_Navigare_in_Sicurezza"
              target="_blank"
              >LEGGI I NOSTRI CONSIGLI SU COME NAVIGARE IN SICUREZZA</a
            >
          </h4>
        </div>
      </section>
      <section class="mb-10">
        <h2 class="text-primary text-title-sm">
          SICUREZZA E CARTE DI PAGAMENTO
        </h2>
        <div class="prose">
          <p>
            <span class="font-bold uppercase">Codice di sicurezza CV2</span
            ><br />
            Il CV2 (CVV2 per Visa, CVC2 per Mastercard) è il codice di sicurezza
            costituito dalle ultime 3 cifre presenti sul retro della carta di
            pagamento e viene richiesto ad ogni acquisto on line per verificare
            che la carta sia realmente in possesso dell’acquirente.
          </p>

          <p>
            <span class="font-bold uppercase">CHIP&PIN</span><br />
            La tecnologia <b>“Chip & Pin”</b> combina lo standard delle carte
            con microchip con l’utilizzo del Pin al posto della firma per
            autorizzare le transazioni. In questo modo, anche se la carta
            finisce in mani sbagliate, l’accesso alle tue informazioni sarà
            molto più difficile.
          </p>

          <p>
            <span class="font-bold uppercase">3D Secure</span><br />
            Il 3DSecure (3DS) è un sistema avanzato di protezione antifrode che
            garantisce una maggiore tutela per gli acquisti online, in quanto
            abbina la carta di pagamento a un codice univoco e diverso per ogni
            acquisto che viene richiesto per autorizzare il pagamento sui siti
            convenzionati.
          </p>
          <p class="font-bold">
            Ti ricordiamo che per tenere sotto controllo gli acquisti con carta
            puoi attivare il servizio di sms alert che ti avvisa di ogni spesa.
          </p>
        </div>
      </section>
    </div>
  </app-popup-page>
</template>

<script>
import { axios } from "@/plugins/axios";
export default {
  props: { navigate: { default: null } },
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  }
};
</script>

<route>
{
  "name": "Sicurezza",
    "meta": {
  }
}
</route>

<style>
.container-section-security {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
</style>
